import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty, DisplayType } from '~/types/specialty';

/**
 * Configuration for Pediatrics specialty referral form
 */
export const pediatricsConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.PEDIATRICS,
  displayName: 'Pediatrics',
  requiresToothSelection: true,
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [
    {
      name: 'Behavior Diagnosis',
      displayType: DisplayType.DROPDOWN,
      options: ['Definitely Negative', 'Negative', 'Positive', 'Definitely Positive'],
    },
  ],
  booleanQuestions: [
    {
      id: 'prior_treatment',
      text: 'Prior treatment attempted?',
    },
    {
      id: 'refer_back',
      text: 'Refer patient back to the referring office for recare?',
    },
  ],
  dateFields: [
    {
      id: 'lastProcedureDate',
      label: 'Date of Last Procedure',
      required: false,
    },
  ],
};
